function changeProgressBar(currentSlide, index){
	if(!!currentSlide){
		if(!!currentSlide.querySelector(`.multi-column__item-${currentSlide.getAttribute('section-id')}.is-selected`)) {
			let slideSelected = currentSlide.querySelector(`.multi-column__item-${currentSlide.getAttribute('section-id')}.is-selected`);
			if(!!slideSelected.getAttribute('data-blocks-size')) {
				let blocksSize = slideSelected.getAttribute('data-blocks-size');
				let progress = 100 / Number(blocksSize);
			
				let currentindex = index + 1;

				if (currentindex === Number(blocksSize)) {
					progress = 100;
				} else {
					progress = progress * currentindex;
				}
				
				if(!!document.querySelector(`.progress-bar-${currentSlide.getAttribute('section-id')}`)){
					let progressBar = document.querySelector(`.progress-bar-${currentSlide.getAttribute('section-id')}`);
					progressBar.style.width = progress + '%';
				}
			}
		}
	}
}

window.addEventListener("flickity:slide-changed", function (e) {
	if(!!e.target) {
		changeProgressBar(e.target, e.detail)
	}
});
